import React from 'react'

import { Image } from 'semantic-ui-react'

import { GameType, Stage, StagePack } from '../types'

const imagePath: string = "stages/images";

interface Props {
  stage?: Stage,
  gameType: GameType
}

export const GetStageImage = (stage: Stage, gameType: GameType) => {
  if (gameType === GameType.Ultimate) {
    return stage.Image;
  }
  const ctx = require(`../${imagePath}/${stage.Image}`);
  return ctx;
}

export default function StageComponent({ stage, gameType }: Props) {

  const stageImage = () => {
    if (!stage) return null;
    const img = GetStageImage(stage, gameType)
    return (
      <Image className="stage-img" src={img} alt={stage!.Image} />
    )
  }
  return (
    <div className='stage-container'>
      {stageImage()}
      <h2>{stage!.Name}</h2>
    </div>
  )
}

export const GetMeleeStageIncludeMod = (stageName: string, preferredPack?: StagePack): Stage => {
  const stagePacks = require(`./meleeStagePacks.json`);

  const lookupInPack = (pack: any): string | undefined => {
    if (!pack) return undefined;
    for (const category in pack) {
      if (!pack.hasOwnProperty(category)) continue;
      const stages = pack[category];
      if (stages.hasOwnProperty(stageName)) return stages[stageName];
    }
    return undefined;
  }

  if (preferredPack) {
    const hit = lookupInPack(stagePacks[preferredPack]);
    if (hit) return { Name: stageName, Image: hit };
  }

  for (const packName in stagePacks) {
    if (!stagePacks.hasOwnProperty(packName)) continue;
    if (packName === preferredPack) continue;
    const hit = lookupInPack(stagePacks[packName]);
    if (hit) return { Name: stageName, Image: hit };
  }
  return { Name: stageName };
}

